import { connect } from 'react-redux'
import PageEntrepreneurship from './PageEntrepreneurship.component'
import { saveOriginPath, retrivePropertyTypes } from '../../actions/searchBar'
import { setPhone } from '../../actions/header'
import * as urls from '../../constants/api'
import { searchPropiedades } from '../../actions/propiedades'
import { TEL_ENTREPRENEURSHIPS } from '../../constants/phones'
import {
  loadNewsBySector,
  loadImisBySector,
  loadVentures,
  loadVenturesById,
  loadDirectorsBySector,
  loadBrokers
} from '../../actions/entrepreneurship'

const mapStateToProps = (state) => {
  return {
    directors: state.entrepreneurship.directors,
    brokers: state.entrepreneurship.brokers,
    news: state.entrepreneurship.news,
    imis: state.entrepreneurship.imis,
    list: state.entrepreneurship.list,
    total: state.entrepreneurship.total,
    current_page: state.entrepreneurship.current_page,
    last_page: state.entrepreneurship.last_page,
    services: state.app.sectors.filter(value => value.name=='emprendimientos'),
    store: state
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadVentures: (pl) => dispatch(loadVentures(pl)),
    setPhone: () => dispatch(setPhone(TEL_ENTREPRENEURSHIPS)),
    didMount: value => {
      dispatch(retrivePropertyTypes(urls.ENTREPENEURSHIP))
      dispatch(saveOriginPath(value))
    },
    loadNewsBySector: () => {
      dispatch(loadNewsBySector(8)),
      dispatch(loadImisBySector(8))
    },
    loadVenturesById: id => dispatch(loadVenturesById(id)),
    searchPropiedades: () => dispatch(searchPropiedades()),
    loadDirectors: () => dispatch(loadDirectorsBySector(8)),
    loadBrokers: () => dispatch(loadBrokers(8)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageEntrepreneurship)



// WEBPACK FOOTER //
// ./src/features/PageEntrepreneurship/PageEntrepreneurship.container.js